import React from 'react'
import { Alert } from 'antd'

const NoSubmissionsWarning = () => {
  return (
    <Alert
      type="warning"
      showIcon
      message="No Successful GSE Submissions"
      description="There are no successful GSE submissions for this inspection. Proceeding will complete data collection without any GSE submissions on record."
      data-testid="no-submissions-warning"
    />
  )
}

export default NoSubmissionsWarning
